import noop from 'lodash/noop';
import { createContext, useContext } from 'react';
import { Content } from '@/lib';

export interface ContentGalleryContextState {
  images: Content.Image[];
  selectedImage: Content.Image | null;
  setSelectedImage: (image: Content.Image | null) => void;
}

const ContentGalleryContext = createContext<ContentGalleryContextState>({
  images: [],
  selectedImage: null,
  setSelectedImage: noop,
});

export default ContentGalleryContext;

export function useContentGallery(): ContentGalleryContextState {
  return useContext(ContentGalleryContext);
}
